import React, { useState, useEffect } from "react";

import { analytics } from "./Helpers/firebase";

import MainSuccess from "./MainSuccess";
import MainInitial from "./MainInitial";
import { PrivacyLink } from "./FormComponents";

const Main = () => {
  const [formSuccess, setFormSuccess] = useState(false);

  useEffect(() => {
    analytics.logEvent("form_load", {
      location: window.location
    });
  }, []);

  return (
    <main>
      <MainInitial setFormSuccess={setFormSuccess} isHidden={formSuccess} />
      <MainSuccess isHidden={!formSuccess} />
      <PrivacyLink />
    </main>
  );
};

export default Main;
